export const HOME = '/';

export const PROTOCOL = '/protocol';
export const MM_PROTOCOL = '/mm-protocol';
export const PROTOCOL_BUILDER = '/protocol-builder';

export const LOGIN = '/login';
export const ACCOUNT = '/account';
export const CHANGE_USERNAME = 'change-username';
export const CHANGE_PASSWORD = 'change-password';
export const UNSUBSCRIBE = '/unsubscribe'
export const DELETE_ACCOUNT = "/delete-account";

export const PRODUCTS = 'products';
export const SIMILAR = 'similar';
export const LISTINGS = 'listings';
export const NEW = 'new';
export const SAVE_PUBLIC_PROTOCOL = 'save-public-protocol';
export const SAVE_MM_PROTOCOL = 'save-mm-protocol';
export const NEW_PRICE = 'new-price';
export const SAVINGS = 'savings';
export const VENDORS = 'vendors';
export const SUBMIT_TAX = 'submit-tax';
export const PRICE_UPDATE_STATUS = '/price-update-status';

export const COMBINE_PROTOCOLS = '/combine-protocols';

export const FUNDRAISERS = '/fundriasers';

export const ABOUT = '/about';
export const WHY = 'why';
export const WHO = 'who';
export const PLANS = 'plans';

export const BLOG = '/blog';
export const INVESTING = 'investing';

export const CONTACT = '/contact';
export const MM_INDEX = '/mm-index';
export const TOPIC = 'topic';
export const ADD_REF = 'add-ref';

export const LICENSES = '/licenses';
export const FONTS = 'fonts';
export const SOFTWARE = 'software';